
import {defineComponent} from 'vue';
import {userLoginURL} from "@/config/app-settings";
import axios from "axios";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Card from "primevue/card";
import Message from "primevue/message";

export default defineComponent({
  name: 'Login',
  components: {Button, InputText, Card, Message},
  data() {
    return {
      error: false,
      errorMessage: '',
      forgotPw: false,
      email: '',
      password: ''
    }
  },
  computed: {
    readyToLogin(): boolean {
      return this.email.length > 0 && this.password.length >= 8;
    },
    emailChanged(): boolean {
      return this.$store.state.emailChanged
    }
  },
  methods: {
    login() {
      this.error = false
      axios.post(userLoginURL, {
        email: this.email,
        password: this.password
      }).then(res => {
        this.$store.dispatch('login', res.data)
            .then(() => this.$router.push({name: 'Home'}))
      }).catch(() => {
        this.errorMessage = 'login.wrong_credentials'
        this.error = true
      })
    },
    resetPassword() {
      this.$emit('resetPw')
      this.$router.push({name: 'ResetPw'});
    },
    toRegister() {
      this.$emit('register')
      this.$router.push({name: 'Register'});

    }
  }
});
